import { render, staticRenderFns } from "./RefinementFilters.vue?vue&type=template&id=115309de&scoped=true&"
import script from "./RefinementFilters.vue?vue&type=script&lang=js&"
export * from "./RefinementFilters.vue?vue&type=script&lang=js&"
import style0 from "./RefinementFilters.vue?vue&type=style&index=0&id=115309de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115309de",
  null
  
)

export default component.exports